/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { HandAndMachineBendFamilyInformation } from '../../components/add-family-information/hand-and-machine-bend-family-information/hand-and-machine-bend-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class HandAndMachineBendFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = HandAndMachineBendFamilyInformation;
    sysquePopupConfig.width = 1280;
      sysquePopupConfig.height = 765;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}